export const DEAL_CONTACT_ROLES = {
    decision_maker: 'Decision Maker',
    economic_buyer: 'Economic Buyer',
    technical_buyer: 'Technical Buyer',
    business_user: 'Business User',
    influencer: 'Influencer',
    champion: 'Champion'
};

export const DEAL_CONTACT_ROLE_ORDER = Object.keys(DEAL_CONTACT_ROLES);

export function getDealContactRoleLabel(key) {
    return DEAL_CONTACT_ROLES[key] || key;
}
